import { Smartphone, UserCheck, PowerOff, Lock } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal } from "./Reveal";

const ICONS = { Smartphone, UserCheck, PowerOff, Lock };

export default function Control() {
  const { t } = useLang();
  return (
    <section id="control" className="mx-auto max-w-7xl px-4 sm:px-8 py-20 sm:py-32">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-20">
        <div>
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#f5a623]">
              {t.control.kicker}
            </p>
            <h2 className="mt-3 font-black tracking-tighter text-3xl sm:text-4xl">
              {t.control.title}
            </h2>
            <p className="mt-5 text-[#a1a1aa] leading-relaxed max-w-lg">{t.control.intro}</p>
          </Reveal>

          <div className="mt-10 space-y-4">
            {t.control.points.map((point, i) => {
              const Icon = ICONS[point.icon];
              return (
                <Reveal key={point.title} delay={i * 0.07}>
                  <div
                    data-testid={`control-point-${i}`}
                    className="flex gap-4 rounded-2xl border lp-hairline bg-white/[0.02] p-5 hover:border-[#f5a623]/40 transition-colors"
                  >
                    <span className="shrink-0 grid place-items-center w-11 h-11 rounded-xl bg-[#f5a623]/12 border border-[#f5a623]/25 text-[#f5a623]">
                      <Icon size={20} />
                    </span>
                    <div>
                      <h3 className="font-bold tracking-tight">{point.title}</h3>
                      <p className="mt-1 text-sm text-[#a1a1aa] leading-relaxed">{point.text}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>

        <div className="relative">
          <div className="lg:sticky lg:top-28 flex justify-center gap-5">
            <Reveal delay={0.1}>
              <div className="w-[210px] sm:w-[240px] rounded-[32px] border border-white/12 bg-[#0d0d10] p-2 shadow-2xl rotate-[-4deg]">
                <img
                  src="/screens/historial.svg"
                  alt={t.how.steps[2].alt}
                  width="390"
                  height="800"
                  loading="lazy"
                  className="rounded-[24px] w-full h-auto"
                />
              </div>
            </Reveal>
            <Reveal delay={0.25}>
              <div className="w-[210px] sm:w-[240px] rounded-[32px] border border-white/12 bg-[#0d0d10] p-2 shadow-2xl rotate-[4deg] mt-12">
                <img
                  src="/screens/reportes.svg"
                  alt={t.control.imgAlt}
                  width="390"
                  height="800"
                  loading="lazy"
                  className="rounded-[24px] w-full h-auto"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
